import type { RouteObject } from "react-router-dom";
import BlogHub from "../pages/blog/page";
import BlogIsde from "../pages/blog/isde-subsidie-2026/page";
import BlogCondens from "../pages/blog/condens-ramen-oplossen/page";
import BlogKozijnSchilderen from "../pages/blog/kozijn-schilderen-vs-vervangen/page";
import BlogHrGlas from "../pages/blog/subsidie-hr-glas-2026/page";
import BlogIsdeEindhoven from "../pages/blog/isde-subsidie-eindhoven/page";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Diensten from "../pages/diensten/page";
import WieZijnWij from "../pages/wie-zijn-wij/page";
import Contact from "../pages/contact/page";
import KozijnReparatie from "../pages/kozijn-reparatie/page";
import SchuifpuiReparatie from "../pages/schuifpui-reparatie/page";
import RedirectDraaikiepraam from "../pages/draaikiepraam-afstellen/page";
import SlotCilinderVervangen from "../pages/slot-cilinder-vervangen/page";
import GlasVervangen from "../pages/glas-vervangen/page";
import VeluxReparatie from "../pages/velux-reparatie/page";
import InbraakschadeReparatie from "../pages/inbraakschade-reparatie/page";
import RaamkrukVervangen from "../pages/raamkruk-vervangen/page";
import SlotenmakerEindhoven from "../pages/slotenmaker-eindhoven/page";
import AlgemeneVoorwaarden from "../pages/algemene-voorwaarden/page";
import Privacybeleid from "../pages/privacybeleid/page";
import Cookiebeleid from "../pages/cookiebeleid/page";
import Centrum from "../pages/wijken/centrum/page";
import Strijp from "../pages/wijken/strijp/page";
import Gestel from "../pages/wijken/gestel/page";
import Veldhoven from "../pages/wijken/veldhoven/page";
import Woensel from "../pages/wijken/woensel/page";
import Tongelre from "../pages/wijken/tongelre/page";
import Stratum from "../pages/wijken/stratum/page";
import Geldrop from "../pages/wijken/geldrop/page";
import Wijken from "../pages/wijken/page";
import RamenReparatie from "../pages/ramen-reparatie/page";
import DraaikiepraamReparatie from "../pages/draaikiepraam-reparatie/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/",
    element: <BlogHub />,
  },
  {
    path: "/blog/isde-subsidie-2026/",
    element: <BlogIsde />,
  },
  {
    path: "/blog/condens-ramen-oplossen/",
    element: <BlogCondens />,
  },
  {
    path: "/blog/kozijn-schilderen-vs-vervangen/",
    element: <BlogKozijnSchilderen />,
  },
  {
    path: "/blog/subsidie-hr-glas-2026/",
    element: <BlogHrGlas />,
  },
  {
    path: "/blog/isde-subsidie-eindhoven/",
    element: <BlogIsdeEindhoven />,
  },
  {
    path: "/onze-diensten/",
    element: <Diensten />,
  },
  {
    path: "/wie-zijn-wij/",
    element: <WieZijnWij />,
  },
  {
    path: "/contact/",
    element: <Contact />,
  },
  {
    path: "/ramen-reparatie/",
    element: <RamenReparatie />,
  },
  {
    path: "/kozijn-reparatie/",
    element: <KozijnReparatie />,
  },
  {
    path: "/schuifpui-reparatie/",
    element: <SchuifpuiReparatie />,
  },
  {
    path: "/draaikiepraam-reparatie/",
    element: <DraaikiepraamReparatie />,
  },
  {
    path: "/draaikiepraam-afstellen/*",
    element: <RedirectDraaikiepraam />,
  },
  {
    path: "/slot-cilinder-vervangen/",
    element: <SlotCilinderVervangen />,
  },
  {
    path: "/glas-vervangen/",
    element: <GlasVervangen />,
  },
  {
    path: "/velux-reparatie/",
    element: <VeluxReparatie />,
  },
  {
    path: "/inbraakschade-reparatie/",
    element: <InbraakschadeReparatie />,
  },
  {
    path: "/raamkruk-vervangen/",
    element: <RaamkrukVervangen />,
  },
  {
    path: "/slotenmaker-eindhoven/",
    element: <SlotenmakerEindhoven />,
  },
  {
    path: "/algemene-voorwaarden/",
    element: <AlgemeneVoorwaarden />,
  },
  {
    path: "/privacybeleid/",
    element: <Privacybeleid />,
  },
  {
    path: "/cookiebeleid/",
    element: <Cookiebeleid />,
  },
  {
    path: "/wijken/",
    element: <Wijken />,
  },
  {
    path: "/wijken/centrum/",
    element: <Centrum />,
  },
  {
    path: "/wijken/strijp/",
    element: <Strijp />,
  },
  {
    path: "/wijken/gestel/",
    element: <Gestel />,
  },
  {
    path: "/wijken/veldhoven/",
    element: <Veldhoven />,
  },
  {
    path: "/wijken/woensel/",
    element: <Woensel />,
  },
  {
    path: "/wijken/tongelre/",
    element: <Tongelre />,
  },
  {
    path: "/wijken/stratum/",
    element: <Stratum />,
  },
  {
    path: "/wijken/geldrop/",
    element: <Geldrop />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;